import {gql} from "@apollo/client";

export const CREATE_SORTER = gql`
    mutation CreateSorter($input: CreateSorterInput!) {
        createSorter(input: $input) {
            id
            sorterCode
            sorterName
            sorterIp
            sorterPort
            sorterStatus
            sorterType
            warehouseId
            chuteConfig
            disabledChuteConfig
            fallbackChuteConfig
            createdAt
            createdBy
            updatedAt
            updatedBy
        }
    }
`;

export interface CreateSorterResponse {
    createSorter: {
        id: string;
        sorterCode?: string;
        sorterName?: string;
        sorterIp?: string;
        sorterPort?: string;
        sorterStatus: number;
        sorterType: number;
        warehouseId: number;
        chuteConfig: string;
        disabledChuteConfig?: string;
        fallbackChuteConfig?: string;
        createdAt?: number;
        createdBy?: string;
        updatedAt?: number;
        updatedBy?: string;
    };
}

export interface CreateSorterVariables {
    input: {
        id?: number;
        sorterCode: string;
        sorterName: string;
        sorterIp?: string;
        sorterPort?: string;
        sorterStatus: number;
        sorterType: number;
        warehouseId: number;
        chuteConfig?: string;
        disabledChuteConfig?: string;
        fallbackChuteConfig?: string;
    };
}

